import Resources from './resources';
import msgActions from '../src/actions/message_modal_actions';

const InvalidSession = 'Invalid session. Please login and try again.';
const LOCAL_MESSAGES = {
    title: 'Oops!',
    Permission: 'You don\'t seem to have the right permissions to access this.',
    InvalidCredential: 'It seems that you are not authorised to access something.' +
    ' Please try again or come back later.',
    InvalidSession,
    MissingToken: InvalidSession,
    TamperedToken: InvalidSession,
    ExpiredToken: InvalidSession,
    INVALID_TOKEN: InvalidSession,
    E404: 'We\'re very sorry but there is something we really can\'t find.' +
    ' Please try again or come back later.',
    E500: 'An error occurred somewhere in the avatar factory. Please try again or come back later.',
    UNKNOWN: 'Something went really wrong. Please try again or come back later.'
};

class ErrorHandling {
    static addResourceResponseErrorInterceptor(dispatch) {
        const interceptor = ErrorHandling.handleErrors.bind(this, dispatch);
        Resources.env.addResponseInterceptor(interceptor);
    }
    
    static handleErrors(dispatch, result) {
        let message;
        let title;
        let valid = false;
        
        try {
            switch (result.status) {
                case 200:
                case 201:
                case 204:
                    valid = true;
                    break;
                
                case 401:
                    title = 'Invalid Session';
                    message = LOCAL_MESSAGES.InvalidSession;
                    break;
    
                case 400:
                case 404:
                case 500:
                    title = 'Server Error';
                    message = LOCAL_MESSAGES.UNKNOWN;
                    break;
                
                default:
                    message = result.message;
            }
        } catch (e) {
            message = LOCAL_MESSAGES.UNKNOWN;
        }
        /**
         * Pass actual message into the final object to broadcast it
         */
        if (message) {
            result.message = message;
        }
        
        if (title) {
            result.title = title;
        }
        
        if (message === LOCAL_MESSAGES.InvalidSession) {
            dispatch(msgActions.openModal({
                contentType: 0,
                heading: title,
                content: message
            }));
        }
        
        /**
         * Pass Errors to Local actions to handle explicitly
         * when result.valid === true BUT
         * result contains result.message && result.code,
         * it means it requires to handle in async functions response
         */
        result.valid = valid;
        
        return result;
    }
}

export default ErrorHandling;
